import "./AriaLabel.scss"

interface IAriaLabelProps {
  /** Elementos HTML / Componentes declarados entre as tags de abertura e fechamento do componente AriaLabel e que serão renderizados */
  children?: JSX.Element | string
  /** Texto que será lido pelo leitor de tela */
  ariaText: string
}

const AriaLabel = ({ children, ariaText = "" }: IAriaLabelProps) => {
  return (
    <div className="ds-aria-helper">
      <span
        role="text"
        aria-label={ariaText}
        className="ds-aria-helper__accessible-text"
      ></span>
      {children}
    </div>
  )
}

export default AriaLabel
